// Helper function to detect dark mode (disabled to ignore system preference)
const isDarkMode = () => {
    return false; // Always return false to ignore system preference
};

// Dynamic color function
const getDynamicColor = (lightColor, darkColor) => {
    return isDarkMode() ? darkColor : lightColor;
};

export const colorWheel = {
    //Neutral - with dark mode support
    white: getDynamicColor('#FFF', '#1a1a1a'),
    lightGrey: getDynamicColor('#FBFBFB', '#2a2a2a'),
    mediumGrey: getDynamicColor('#EBEBEB', '#3a3a3a'),
    neutral3: getDynamicColor('#BCBEC0', '#6a6c6f'),
    neutral4: getDynamicColor('#9d9d9d', '#8d8d8d'),
    graniteGrey: getDynamicColor('#747679', '#9a9b9e'),
    textGrey: getDynamicColor('#373534', '#e8e8e8'),
    black: getDynamicColor('#000', '#ffffff'),
    bodyGray: getDynamicColor('#f5f5f5', '#2d2d2d'),
    editableCardHeader: getDynamicColor('#f0f0f0', '#3d3d3d'),

    //Sky Blue
    skyBlue1: '#F5FBFD',
    skyBlue2: '#CCEDF8',
    skyBlue3: '#CCEDF8',
    skyBlue: '#419BD8', //sky blue replacement
    skyBlue5: '#005777',

    //Steel Blue
    steelBlue1: '#F5F8FB',
    steelBlue2: '#3379A9',
    steelBlue: '#005893',
    steelBlue4: '#004676',
    steelBlue5: '#003E67',

    //Purple
    purple1: '#FBF8FB',
    plumPurple: '#71277A',
    purple3: '#39143D',

    //Khaki
    khaki1: '#FCFBF7',
    khakiTan: '#DED3B0',
    khaki3: '#DED3B0',
    khaki4: '#9B947B',
    khaki5: '#6F6A58',
    khaki6: '#433F35',

    //Red
    red1: '#FAE6E6',
    red2: '#EB9999',
    red: '#CC0000', //wineRed replacement
    red4: '#A30000',
    red5: '#8F0000',
    red6: '#520000',

    //Orange
    orange1: '#FEFBF8',
    tangerineOrange: '#F68C3F',
    orange3: '#D26C00',
    orange4: '#B05C03',
    orange5: '#9E5303',

    //Yellow
    yellow1: '#FFFFF5',
    yellow2: '#F5F751',
    ocherYellow: '#D9C700', //ocherYellow replacement
    yellow4: '#AC9106',
    yellow5: '#876800',

    //Green
    green1: '#F9FCF8',
    green2: '#92E998',
    ivyGreen: '#008540', //ivyGreen replacement
    green4: '#006A33',
    alertGreen: '#D5F3CC',

    //Antd component specific colors - with dark mode support
    selectedDropdownOption: getDynamicColor('#e6f7ff', '#2a4d5c'),
    selectedDropdownText: getDynamicColor('rgba(0, 0, 0, .85)', 'rgba(255, 255, 255, .85)'),
    selectedDropdownCheck: '#1890ff',
    dropdownUpDownArrow: getDynamicColor('rgba(0, 0, 0, 0.25)', 'rgba(255, 255, 255, 0.45)'),
    searchInputText: getDynamicColor('#bfbfbf', '#7f7f7f'),
    messageBackground: getDynamicColor('#f8f8f9', '#3a3b3c'),
    fundTypeYellow: '#fbbd08',
    fundTypeGreen: '#21ba45',
    fundTypeRed: '#db2828',
    fundTypeGrey: '#767676',
    mainFooterMenuFocus: '#00548c',
    mainMenuHover: '#f7f7f7',
    mainMenuFocus: '#f2f2f2'
}

export const graphColors = [
    colorWheel.steelBlue,
    colorWheel.tangerineOrange,
    colorWheel.skyBlue,
    colorWheel.plumPurple,
    colorWheel.graniteGrey,
    colorWheel.ivyGreen,
    colorWheel.textGrey,
    colorWheel.ocherYellow,
    colorWheel.red,
    colorWheel.khakiTan
]

export default colorWheel;
